export default __webpack_public_path__ + "static/media/Boiko.5dea909c.png";